import { create, verify as verifyImpl, uint8ArrayToHexString } from './api';
import type { VerifyPowoOptions } from './types';

async function loadSigVerifier() {
  const module = await import('./icp-sig-verifier/sig_verifier_js');
  return module.default || module;
}

export { create, uint8ArrayToHexString };

export const verify = async (
  address: string,
  proof: string,
  options: VerifyPowoOptions,
  currentTimeNsOverride?: bigint,
  iiCanisterIdOverride?: string,
  rootPublicKeyOverride?: Uint8Array
) =>
  verifyImpl(
    loadSigVerifier,
    address,
    proof,
    options,
    currentTimeNsOverride,
    iiCanisterIdOverride,
    rootPublicKeyOverride
  );
